import { render, staticRenderFns } from "./PagesIntro.vue?vue&type=template&id=163f97a4&scoped=true&"
import script from "./PagesIntro.vue?vue&type=script&lang=js&"
export * from "./PagesIntro.vue?vue&type=script&lang=js&"
import style0 from "./PagesIntro.vue?vue&type=style&index=0&id=163f97a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163f97a4",
  null
  
)

export default component.exports